import { useState, useCallback, useEffect } from "react"
import cn from "classnames"
import Link from "next/link"
import useWindowSize from "utilities/useWindowSize"
import richText from "utilities/richText"
import Arrow from "public/assets/teal-arrow.svg"
import getStoryblokLink from "utilities/getStoryblokLink"
import PricingChartColumn from "../atoms/PricingChartColumn"

export default function PricingChart({ columns, discount_banner, pricing_download_link, fine_print_text }) {
  const { width } = useWindowSize()
  const numberOfCols = columns.length
  const lastIndex = numberOfCols - 1

  const defaultIndex = columns.findIndex((col) => {
    return col.mobile_slider_default === true
  })

  const isMembership = columns[0].component === "pricing_membership_column"

  const [currentSlide, setSlide] = useState(defaultIndex || 0)

  const visibleSlides = useCallback(() => {
    if (width >= 1024) {
      return 4
    }
    return 1
  }, [width])

  const prevSlide = () => setSlide(currentSlide === 0 ? lastIndex : currentSlide - 1)

  const nextSlide = () => setSlide(currentSlide === lastIndex ? 0 : currentSlide + 1)

  useEffect(() => {
    if (width >= 1024) {
      setSlide(0)
    }
  }, [currentSlide, width, defaultIndex])

  const gridStyles =
    "transition-transform duration-700 lg:transition-none flex lg:grid lg:gap-[2px] lg:grid-flow-col auto-cols-fr"

  return (
    <>
      <div className="pt-12">
        <div className="overflow-hidden">
          <div className={gridStyles} style={{ transform: `translateX(-${currentSlide * 100}%)` }} aria-live="off">
            {columns.map((column, idx) => (
              <PricingChartColumn {...column} key={idx} discount_banner={discount_banner} />
            ))}
          </div>
          {discount_banner && (
            <div className="hidden lg:block bg-green-sea font-bold text-center py-2 rounded-b-3xl text-black duration-700">
              {discount_banner}
            </div>
          )}
        </div>
        <div className="flex flex-col lg:flex-row lg:justify-end lg:gap-10">
          {fine_print_text && (
            <div className="text-white text-center lg:text-left prose-p:text-s1 prose-p:font-light max-w-sm lg:max-w-full lg:pt-2 lg:pl-4 mx-auto lg:mx-0">
              {richText(fine_print_text)}
            </div>
          )}
          {pricing_download_link?.url ? (
            <Link
              target="_blank"
              href={getStoryblokLink(pricing_download_link)}
              className="text-white table  font-bold pt-2 underline hover:no-underline mx-auto lg:mx-0"
            >
              Download full pricing menu
            </Link>
          ) : null}
        </div>
        {visibleSlides() < 4 ? (
          <div className="">
            <button onClick={prevSlide} aria-label="Previous Slide">
              <Arrow
                className={cn({
                  "carousel-arrow absolute left-3 md:left-36": true,
                  "bottom-[32rem]": isMembership,
                  "bottom-[22.5rem]": !isMembership,
                })}
              />
            </button>
            <button onClick={nextSlide} aria-label="Next Slide">
              <Arrow
                className={cn({
                  "carousel-arrow absolute right-3 md:right-36 rotate-180": true,
                  "bottom-[32rem]": isMembership,
                  "bottom-[22.5rem]": !isMembership,
                })}
              />
            </button>
          </div>
        ) : null}
      </div>
    </>
  )
}
